// import { Component } from '@angular/core';
import $ from "jquery";
import "select2";
import {
    Component,
    OnInit,
    inject,
    computed,
    ChangeDetectionStrategy,
    signal,
    OnDestroy,
    Renderer2,
    HostBinding
} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AppService} from '@services/app.service';
import {ApiService} from '@services/api.service';

import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';
//MATERIAL AUTOCOMPLETE
// import { Component } from '@angular/core';
import {FormControl, FormGroup,FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {AsyncPipe} from '@angular/common';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
//MATERIAL AUTOCOMPLETE END
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {merge} from 'rxjs';

import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface State {
  location_id: string,
  name: string,
  district: string,
  branch_id: string,
}

  // imports: [
  //   FormsModule,
  //   MatFormFieldModule,
  //   MatInputModule,
  //   MatAutocompleteModule,
  //   ReactiveFormsModule,
  //   AsyncPipe,
  // ],

@Component({
  selector: 'app-add-customer',
  // standalone: true,
  // imports: [],
  templateUrl: './add-customer.component.html',
  styleUrl: './add-customer.component.scss'
})
export class AddCustomerComponent {
  private apiService = inject(ApiService);
  // public addCustomerForm: UntypedFormGroup;

  protected readonly value = signal('');

  protected onInput(event: Event) {
    this.value.set((event.target as HTMLInputElement).value);
  }
    // MATERIAL FORM select
  // readonly email = new FormControl('', [Validators.required, Validators.email]);
  readonly email = new FormControl('', [Validators.email]);
  errorMessage = signal('');

  readonly mobile= new FormControl('',[Validators.required,Validators.pattern('[0-9]*'), Validators.minLength(7),Validators.maxLength(7)]);
  errorMessage2 = signal('');

  stateCtrl = new FormControl('');
  filteredStates: Observable<State[]>;

  states: State[] = [];


  addCustomerForm = new FormGroup({
      company_name: new FormControl(''),
      first_name: new FormControl('',[Validators.required]),
      last_name: new FormControl('',[Validators.required]),
      address: new FormControl(''),
      location_id: new FormControl('',[Validators.required]),
      mobile: new FormControl('',[Validators.required,Validators.pattern('[0-9]*'), Validators.minLength(7),Validators.maxLength(7)]),
      email: new FormControl('',[Validators.email])
  });
    // MATERIAL FORM select END

    public users;
    public SelectedLocation;
    public client;
    public date;
    public new_client;
    public now: string;
    public topResults;
    public locations;
    // public topResults: any = null;


      clickMessage = '';

    // public client: any = null;
    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private route: ActivatedRoute,
        private router: Router

    ) { 
        this.new_client = {};

         merge(this.email.statusChanges, this.email.valueChanges)
          .pipe(takeUntilDestroyed())
          .subscribe(() => this.updateErrorMessage());

        merge(this.mobile.statusChanges, this.mobile.valueChanges)
          .pipe(takeUntilDestroyed())
          .subscribe(() => this.updateErrorMessage2());

        this.filteredStates = this.stateCtrl.valueChanges.pipe(
          startWith(''),
          map(state => (state ? this._filterStates(state) : this.states.slice())),
        );

          setInterval(() => {
            this.now = new Date().toString();
          }, 1);
    }


  ngOnInit() {
      }


  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();

    return this.states.filter(state => state.name.toLowerCase().includes(filterValue));
  }

  async onTouch() {
        try {
            await this.appService.getLocations();
            this.states = this.appService.users;
            console.log('locations inside ONTOUCH  :::',this.locations);

            this.filteredStates = this.stateCtrl.valueChanges.pipe(
              startWith(''),
              map(state => (state ? this._filterStates(state) : this.states.slice())),
            );
            return true;
        } catch (error) {
            return false;
        }
    }
  async searchClientById(value){
        try {
            await this.appService.getClientById(value);
            this.client = this.appService.client;
            console.log('users inside client async',this.client);
            return true;

        } catch (error) {
            return false;
        }
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    console.log('Selected value:', event.option.id);
    this.SelectedLocation = event.option.id.toString();

      this.addCustomerForm.patchValue({
        location_id: this.SelectedLocation,
      });
  }

  clearInput(): void {
    this.stateCtrl.reset();
  }

  addCustomer(){
     if (this.addCustomerForm.valid) {
      // console.log('Form Submitted!', this.addCustomerForm.value);
      this.apiService.addCustomer(this.addCustomerForm.value).subscribe({
      next: (response) => {
          // console.log('Data sent successfully:', response);
          this.toastr.success('Added Customer');
          this.addCustomerForm.reset();
          this.stateCtrl.reset();
      },
      error: (error) => {
          this.toastr.error('Added Customer FAILED please contact Engineer');
          // console.error('Error sending data:', error);
      }
    });


    } else {
        this.toastr.error('INVALID FORM');
        console.log('Form is invalid');
    }
  }

  updateErrorMessage() {
    if (this.email.hasError('required')) {
      this.errorMessage.set('You must enter a value');
    } else if (this.email.hasError('email')) {
      this.errorMessage.set('Not a valid email');
    } else {
      this.errorMessage.set('');
    }
  }

  updateErrorMessage2() {
    if (this.mobile.hasError('required')) {
      this.errorMessage2.set('You must enter a value');
    } else if (this.mobile.hasError('minlength')) {
      this.errorMessage2.set('Not a valid phone');
    } else {
      this.errorMessage2.set('');
    }
  }


}
